(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ranty-crosssell-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function merge(host, container) {
      if (container.dataset.rantyMerged) return;
      var first = container.querySelector('.ranty-cross-card');
      if (!first) return;
      container.dataset.rantyMerged = 'true';
      if (first.dataset.source === 'legacy') return;
      var changed = false;
      container.querySelectorAll('[data-ranty-crosssell-item]').forEach(function (item) {
        if (!item.querySelector('form')) { item.remove(); changed = true; }
      });
      var limit = 9;
      try { limit = parseInt(new URL(host.dataset.url, location.origin).searchParams.get('limit'), 10) || 9; } catch (e) {}
      var seen = new Set();
      container.querySelectorAll('.ranty-cross-card').forEach(function (card) { seen.add(card.dataset.pid); });
      var count = seen.size;
      document.querySelectorAll('.ranty-fallback [data-ranty-crosssell-item]').forEach(function (item) {
        var card = item.querySelector('.ranty-cross-card');
        if (!card || count >= limit || seen.has(card.dataset.pid)) return;
        seen.add(card.dataset.pid);
        item.hidden = false;
        container.appendChild(item);
        count += 1;
        changed = true;
      });
      if (count === 0) { var aside = host.querySelector('aside'); if (aside) aside.remove(); return; }
      if (changed) delete container.dataset.rantyPagesReady;
    }
    function init() {
      document.querySelectorAll('product-recommendations.complementary-products').forEach(function (host) {
        if (host.dataset.rantyBound) return;
        host.dataset.rantyBound = 'true';
        function check() { var c = host.querySelector('[data-ranty-crosssell-items]'); if (c) merge(host, c); }
        new MutationObserver(check).observe(host, { childList: true, subtree: true });
        check();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ranty-installments"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ranty-installments')) {
    customElements.define('ranty-installments', class extends HTMLElement {
      connectedCallback() {
        try {
          this.prices = JSON.parse(this.querySelector('[data-installment-prices]').textContent);
        } catch {
          this.prices = [];
        }
        this.updateAmount = this.updateAmount.bind(this);
        this.productInfo = this.closest('product-info') || this.closest('.product__info-container');
        if (this.productInfo) {
          this.productInfo.addEventListener('change', this.updateAmount);
          this.observer = new MutationObserver(this.updateAmount);
          this.observer.observe(this.productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        }
        this.updateAmount();
      }

      disconnectedCallback() {
        if (this.productInfo) this.productInfo.removeEventListener('change', this.updateAmount);
        if (this.observer) this.observer.disconnect();
      }

      updateAmount() {
        const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
        const selectedId = form?.querySelector('input[name="id"]')?.value;
        const variant = this.prices.find(item => item.id === selectedId);
        if (!variant) return;
        const count = Number(this.dataset.count) || 6;
        const pesos = Math.ceil(Number(variant.price) / 100 / count);
        const formatted = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(pesos);
        const amount = this.querySelector('[data-installment-amount]');
        if (amount && amount.textContent !== formatted) amount.textContent = formatted;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
